import clsx from 'clsx';
import React, { useMemo } from 'react';
import styles from './StatsTable.module.scss';
import { T, Tooltip } from '@colonist/ui';
import IconHighlightCircle from '@static/images/icon_highlight_circle.svg';
export const StatsTable = ({ className, headers, rows, enableHighlight, rowProps })=>{
    const highlightIndices = useMemo(()=>{
        if (rows.length === 0) {
            return [];
        }
        const columnCount = headers.length;
        const initial = Array(columnCount).fill(Number.MIN_SAFE_INTEGER);
        const maxValues = rows.reduce((acc, row)=>{
            row.forEach((value, colIndex)=>{
                if (value > acc[colIndex]) {
                    acc[colIndex] = value;
                }
            });
            return acc;
        }, initial);
        return maxValues.map((maxValue, colIndex)=>rows.findIndex((row)=>row[colIndex] === maxValue));
    }, [
        rows
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.headerContainer
    }, headers.map((header, index)=>/*#__PURE__*/ React.createElement(Tooltip, {
            centerText: true,
            key: index,
            title: /*#__PURE__*/ React.createElement(T, {
                id: header.tooltip
            })
        }, /*#__PURE__*/ React.createElement("img", {
            className: clsx(styles.headerIcon, {
                [styles.clickable]: header.onClick
            }),
            key: index,
            onClick: header.onClick,
            src: header.imagePath
        })))), rows.map((values, rowIndex)=>/*#__PURE__*/ React.createElement("div", {
            className: styles.rowContainer,
            key: rowIndex
        }, values.map((value, colIndex)=>{
            var _rowProps_colIndex, _rowProps_colIndex1, _rowProps_colIndex_rowRenderer, _rowProps_colIndex2;
            const shouldHighlight = enableHighlight && rowIndex === highlightIndices[colIndex];
            const displayValue = value !== null && value !== void 0 ? value : 0;
            return /*#__PURE__*/ React.createElement("div", {
                className: styles.valueContainer,
                key: colIndex
            }, shouldHighlight && !(rowProps === null || rowProps === void 0 ? void 0 : (_rowProps_colIndex = rowProps[colIndex]) === null || _rowProps_colIndex === void 0 ? void 0 : _rowProps_colIndex.disableRowHighlight) && /*#__PURE__*/ React.createElement("img", {
                className: styles.highlight,
                src: IconHighlightCircle
            }), /*#__PURE__*/ React.createElement("div", {
                className: styles.value
            }, (rowProps === null || rowProps === void 0 ? void 0 : (_rowProps_colIndex1 = rowProps[colIndex]) === null || _rowProps_colIndex1 === void 0 ? void 0 : _rowProps_colIndex1.rowRenderer) ? rowProps === null || rowProps === void 0 ? void 0 : (_rowProps_colIndex2 = rowProps[colIndex]) === null || _rowProps_colIndex2 === void 0 ? void 0 : (_rowProps_colIndex_rowRenderer = _rowProps_colIndex2.rowRenderer) === null || _rowProps_colIndex_rowRenderer === void 0 ? void 0 : _rowProps_colIndex_rowRenderer.call(_rowProps_colIndex2, value) : displayValue));
        }))));
};
